module.exports = __webpack_public_path__ + "assets/media/line-graph.20498a07.svg";